





































































































































































































































































































































































































































import { Vue, Component, Ref, Watch  } from 'vue-property-decorator'
import AlertModule from '@/store/vuex/aplicacao/AlertModule'
import type { AtributoMarketplace, CanalVendaMarketplace, CanalVendaMarketplaceProduto, DadosAdicionais, ImagemProduto, Loja, Produto, ProdutoMarketplace, TipoDeProduto, VideoMarketplace } from '@/models'
import CamposDeEndereco from '../ui/CamposDeEndereco.vue'
import { obrigatorio } from '@/shareds/regras-de-form'
import BuscaDeProdutoDropdown from '../produto/BuscaDeProdutoDropdown.vue'
import SeletorDeAtributoMarketplace from './SeletorDeAtributoMarketplace.vue'
import SeletorDeCategoriaGlobalMarketplace from './SeletorDeCategoriaGlobalMarketplace.vue'
import DataTableDeCrud from '../ui/DataTableDeCrud.vue'
import DialogoDeVideoMarketplace from './DialogoDeVideoMarketplace.vue'
import DialogoDeCanalDeVendaMarketplace from './DialogoDeCanalDeVendaMarketplace.vue'
import { FindProdutoMarketplaceUseCase } from '@/usecases/marketplace/FindProdutoMarketplaceUseCase'
import { UpdateProdutoMarketplaceUseCase } from '@/usecases/marketplace/UpdateProdutoMarketplaceUseCase'
import SeletorDeTabelaDePreco from '../tabeladepreco/SeletorDeTabelaDePreco.vue'
import { FindItemDaTabelaDePrecoUseCase, FindProdutoUseCase } from '@/usecases'
import WrapperDeUpload from '../ui/WrapperDeUpload.vue'

@Component({
	components: {
		CamposDeEndereco,
		BuscaDeProdutoDropdown,
		SeletorDeAtributoMarketplace,
		SeletorDeCategoriaGlobalMarketplace,
		DataTableDeCrud,
		DialogoDeVideoMarketplace,
		DialogoDeCanalDeVendaMarketplace,
		SeletorDeTabelaDePreco,
		WrapperDeUpload,
	},
})
export default class DialogoProdutoMarketplace extends Vue {
	@Ref() form!: HTMLFormElement
	@Ref() campoDeProduto!: HTMLInputElement
	@Ref() dialogoDeVideoMarketplace!: DialogoDeVideoMarketplace
	@Ref() dialogoDeCanalDeVendaMarketplace!: DialogoDeCanalDeVendaMarketplace
	lojaSelecionada: Loja | null = null
	produtoMarketplaceEmEdicao: ProdutoMarketplace | null = null
	salvando = false
	mostra = false
	atributoCor: AtributoMarketplace | null = null
	atributoTamanho: AtributoMarketplace | null = null
	abas: string[] = ['Principal', 'Imagens', 'Descrição', 'Vídeos', 'Marketplaces', 'Dados Adicionais']
	tab: null | number = null
	headersVideos = [
		{ text: 'Nome', value: 'nome' },
		{ text: 'URL', value: 'url' },
	]
	headersCanaisDeVenda = [
		{ text: 'Marketplace', value: 'canal.codigo' },
		{ text: 'Canal de Venda', value: 'canal.nome' },
		{ text: 'Preço', value: 'preco' },
	]
	reloadVideos = false
	reloadCanaisDeVenda = false
	editando = false
	dadosAdicionais = [] as DadosAdicionais[]
	imagens = [] as ImagemProduto[]

	findProdutoMarketplaceUseCase = new FindProdutoMarketplaceUseCase()
	updateProdutoUseCase = new UpdateProdutoMarketplaceUseCase()
	findItemDaTabelaDePrecoUseCase = new FindItemDaTabelaDePrecoUseCase()
	findProdutoUseCase = new FindProdutoUseCase()

	obrigatorio = obrigatorio
	AlertModule = AlertModule

	get abasPermitidas() {
		if (this.produtoMarketplaceEmEdicao?.produto) {
			return this.abas
		} else {
			return this.abas.filter(aba => aba === 'Principal')
		}
	}

	get tiposDeProdutos() {
		return { tipos: ['Padrão', 'Variante'] as TipoDeProduto [] }
	}

	get unidadesPossiveis() {
		return [
			'Unidade',
			'Quilogramas',
			'Gramas',
			'Miligramas',
			'Metros',
			'Centimetros',
			'Centimetros Quadrados',
			'Centimetros Cubicos',
			'Milimetros',
			'Milimetros Quadrados',
			'Milimetros Cubicos',
			'Libras',
			'Pes',
			'Pes Quadrados',
			'Pes Cubicos',
			'Polegadas',
			'Polegadas Quadradas',
			'Polegadas Cubicas',
			'Caixa',
		]
	}

	get generosPossiveis() {
		return [
			'masculino',
			'feminino',
			'menino',
			'menina',
			'unissex',
		]
	}

	get folderName() {
		return `publico/${window.location.host.split('.')[0]}/marketplace/imagens/produtos`
	}

	get isComVariantes() {
		return this.produtoMarketplaceEmEdicao && this.produtoMarketplaceEmEdicao.variantes.length > 0
	}

	@Watch('produtoMarketplaceEmEdicao.produto')
	async onChangeProduto(produtoAtual: Produto) {
		if (produtoAtual && !this.editando) {
			if (this.produtoMarketplaceEmEdicao && this.produtoMarketplaceEmEdicao.produto && this.lojaSelecionada) {
				const produtoId = this.produtoMarketplaceEmEdicao.produto.id

				try {
					const produtoJaCadastrado = await this.findProdutoMarketplaceUseCase.validaProdutoExistente(produtoId, this.lojaSelecionada.id)

					if (produtoJaCadastrado) {
						this.produtoMarketplaceEmEdicao.produto = null
						AlertModule.setError('Produto já cadastrado para sinconização com os markeplaces')
					}
				} catch(error) {
					AlertModule.setError(error)
				}

				if (this.produtoMarketplaceEmEdicao.produto && this.produtoMarketplaceEmEdicao.produto.tipo === 'Com Variantes') {
					const variantes = await this.findProdutoUseCase.buscarVariantes(this.produtoMarketplaceEmEdicao.produto.id)

					this.produtoMarketplaceEmEdicao.variantes = []
					variantes.map(variante => {
						if (!this.produtoMarketplaceEmEdicao) return

						this.produtoMarketplaceEmEdicao.variantes.push({
							atributoCor: null,
							atributoTamanho: null,
							produto: variante,
						})

						if (variante.urlImagens.length > 0) {
							variante.urlImagens.forEach(urlImagem => {
								this.imagens.push({
									urlImagem: urlImagem.imagemUrl,
									idProduto: variante.id,
								})
							})
						} else if (this.produtoMarketplaceEmEdicao.produto && this.produtoMarketplaceEmEdicao.produto.urlImagens.length > 0) {
							this.produtoMarketplaceEmEdicao.produto.urlImagens.forEach(urlImagem => {
								this.imagens.push({
									urlImagem: urlImagem.imagemUrl,
									idProduto: variante.id,
								})
							})
						}else {
							this.imagens.push({
								urlImagem: '',
								idProduto: variante.id,
							})
						}
					})
				}
			}
		}
	}

	async mostrar(produtoMarketplace: ProdutoMarketplace, loja: Loja) {
		const produtoMarketplaceEmEdicao = new Object() as ProdutoMarketplace
		this.dadosAdicionais = []
		this.tab = 0

		if (produtoMarketplace.id) {
			produtoMarketplaceEmEdicao.id = produtoMarketplace.id

			this.produtoMarketplaceEmEdicao = await this.findProdutoMarketplaceUseCase.get(produtoMarketplace.id)
			this.atributoCor = this.produtoMarketplaceEmEdicao.atributos.filter(atributo => atributo.tipoAtributo === 'Cor')[0]
			this.atributoTamanho = this.produtoMarketplaceEmEdicao.atributos.filter(atributo => atributo.tipoAtributo === 'Tamanho')[0]
			this.dadosAdicionais = this.produtoMarketplaceEmEdicao.dadosAdicionais ? JSON.parse(this.produtoMarketplaceEmEdicao.dadosAdicionais) : []
			this.imagens = this.produtoMarketplaceEmEdicao.imagens ? JSON.parse(this.produtoMarketplaceEmEdicao.imagens) : []
			this.editando = true
		} else {
			this.editando = false
			this.produtoMarketplaceEmEdicao = produtoMarketplace
			this.produtoMarketplaceEmEdicao.origem = 'Nacional'
			this.produtoMarketplaceEmEdicao.genero = 'unissex'
			this.produtoMarketplaceEmEdicao.unidade = 'Unidade'
			this.produtoMarketplaceEmEdicao.descricao = 'SEM DESCRIÇÃO'
			this.imagens = []
		}
		
		this.lojaSelecionada = loja
		this.mostra = true
	}

	esconder() {
		this.mostra = false
		this.produtoMarketplaceEmEdicao = null
	}

	async salvar() {
		if (!this.produtoMarketplaceEmEdicao) return

		this.imagens = this.imagens.filter(imagem => imagem.urlImagem !== null && imagem.urlImagem.trim() !== '')
		if (!this.imagens || this.imagens.length === 0) {
			AlertModule.setWarning('Adicione pelo menos uma imagem para o anúncio deste produto!')
			return
		}

		if (this.isComVariantes) {
			const varianteSemImagem = this.produtoMarketplaceEmEdicao.variantes
				.filter(variante => !this.imagens.map(imagem => imagem.idProduto).includes(variante.produto.id))

			if (varianteSemImagem.length > 0) {
				varianteSemImagem.forEach(variante => {
					this.imagens.push({idProduto: variante.produto.id, urlImagem: null})
				})

				AlertModule.setWarning(`Todas as variantes devem possuir ao menos uma imagem. Variantes sem imagem: ${varianteSemImagem.map(variante => variante.produto.nomeCompleto).join(',')}`)
				return
			}
		}

		if(!this.produtoMarketplaceEmEdicao.canaisVenda || this.produtoMarketplaceEmEdicao.canaisVenda.length === 0) {
			AlertModule.setWarning('Informe pelo menos um canal de venda')
			return
		}

		if (!this.form.validate()) return		
		if (!this.lojaSelecionada) return
		if (!this.produtoMarketplaceEmEdicao.produto) return

		try {
			this.salvando = true

			if (this.produtoMarketplaceEmEdicao.variantes.length === 0) {
				if (!this.atributoCor) return
				if (!this.atributoTamanho) return
				this.produtoMarketplaceEmEdicao.atributos = [this.atributoCor, this.atributoTamanho]
			}
			this.produtoMarketplaceEmEdicao.loja = this.lojaSelecionada
			this.produtoMarketplaceEmEdicao.nome = this.produtoMarketplaceEmEdicao.produto.nome
			this.produtoMarketplaceEmEdicao.dadosAdicionais = JSON.stringify(this.dadosAdicionais)
			this.produtoMarketplaceEmEdicao.imagens = JSON.stringify(this.imagens)

			if (this.produtoMarketplaceEmEdicao.id) {
				this.produtoMarketplaceEmEdicao = await this.updateProdutoUseCase.update(this.produtoMarketplaceEmEdicao)
			} else {
				this.produtoMarketplaceEmEdicao = await this.updateProdutoUseCase.create(this.produtoMarketplaceEmEdicao)
			}
			this.$emit('atualizar', this.produtoMarketplaceEmEdicao)

			this.esconder()
		} catch (error) {
			AlertModule.setError(error)
		} finally {
			this.salvando = false
		}
	}

	abrirDialogoParaAdicionarVideo() {
		this.dialogoDeVideoMarketplace.mostrar(null)
	}

	abrirDialogoParaEditarVideo(indice: any) {
		if(!this.produtoMarketplaceEmEdicao || !this.produtoMarketplaceEmEdicao.videos) return

		const videoEmEdicao = this.produtoMarketplaceEmEdicao.videos[indice]

		this.dialogoDeVideoMarketplace.mostrar(videoEmEdicao)
	}

	adicionarVideo(video: VideoMarketplace) {
		if (!this.produtoMarketplaceEmEdicao) return

		if (this.produtoMarketplaceEmEdicao.videos) {
			this.produtoMarketplaceEmEdicao.videos.push(video)
		} else {
			this.produtoMarketplaceEmEdicao.videos = [video]
		}

		this.reloadComponenteDeVideos()
	}

	salvarVideoEditado(videoEditado: VideoMarketplace) {
		if (!this.produtoMarketplaceEmEdicao) return

		const indiceEditado = this.produtoMarketplaceEmEdicao.videos.findIndex(video => video.id === videoEditado.id)

		if (indiceEditado >= 0) {
			this.produtoMarketplaceEmEdicao.videos.splice(indiceEditado, 1, videoEditado)
		}

		this.reloadComponenteDeCanaisDeVenda()
	}

	removerVideo(indice: any) {
		if (!this.produtoMarketplaceEmEdicao) return
		this.produtoMarketplaceEmEdicao.videos.splice(indice, 1)
		this.reloadComponenteDeVideos()
	}

	async abrirDialogoParaAdicionarCanalDeVenda() {
		if(!this.produtoMarketplaceEmEdicao) return

		const canais = this.produtoMarketplaceEmEdicao.canaisVenda?.map(canal => canal.canal) as CanalVendaMarketplace[] || []

		let precoDeTabela = 0
		if (this.produtoMarketplaceEmEdicao.tabelaDePreco && this.produtoMarketplaceEmEdicao.produto) {
			try {
				if (this.produtoMarketplaceEmEdicao.variantes.length > 0) {
					const itemDaTabelaDePreco = await this.findItemDaTabelaDePrecoUseCase.getByIdDoProduto(this.produtoMarketplaceEmEdicao.tabelaDePreco.id, this.produtoMarketplaceEmEdicao.variantes[0].produto.id)
					precoDeTabela = itemDaTabelaDePreco.precoFinalVarejo || 0
				} else {
					const itemDaTabelaDePreco = await this.findItemDaTabelaDePrecoUseCase.getByIdDoProduto(this.produtoMarketplaceEmEdicao.tabelaDePreco.id, this.produtoMarketplaceEmEdicao.produto.id)
					precoDeTabela = itemDaTabelaDePreco.precoFinalVarejo || 0
				}				
			} catch(error){
				AlertModule.setError('Preço não encontrado para tabela de preço ' + this.produtoMarketplaceEmEdicao.tabelaDePreco.nome)
			}
		}

		this.dialogoDeCanalDeVendaMarketplace.mostrar(null, canais, precoDeTabela)
	}

	abrirDialogoParaEditarCanalDeVenda(indice: any) {
		if(!this.produtoMarketplaceEmEdicao) return

		const canais = this.produtoMarketplaceEmEdicao.canaisVenda?.map(canal => canal.canal) as CanalVendaMarketplace[] || []
		const canalEmEdicao = this.produtoMarketplaceEmEdicao.canaisVenda[indice]

		this.dialogoDeCanalDeVendaMarketplace.mostrar(canalEmEdicao, canais, 0)
	}

	adicionarCanaisVenda(canalVendaProduto: CanalVendaMarketplaceProduto) {
		if (!this.produtoMarketplaceEmEdicao) return

		if (this.produtoMarketplaceEmEdicao.canaisVenda) {
			this.produtoMarketplaceEmEdicao.canaisVenda.push(canalVendaProduto)
		} else {
			this.produtoMarketplaceEmEdicao.canaisVenda = [canalVendaProduto]
		}

		this.reloadComponenteDeCanaisDeVenda()
	}

	salvarCanalEditado(canalVendaProduto: CanalVendaMarketplaceProduto) {
		if (!this.produtoMarketplaceEmEdicao) return

		const indiceEditado = this.produtoMarketplaceEmEdicao.canaisVenda.findIndex(canal => canal.canal?.codigo === canalVendaProduto.canal?.codigo)

		if (indiceEditado >= 0) {
			this.produtoMarketplaceEmEdicao.canaisVenda.splice(indiceEditado, 1, canalVendaProduto)
		}

		this.reloadComponenteDeCanaisDeVenda()
	}

	removerCanalDeVenda(indice: any) {
		if (!this.produtoMarketplaceEmEdicao) return
		this.produtoMarketplaceEmEdicao.canaisVenda.splice(indice, 1)
		this.reloadComponenteDeCanaisDeVenda()
	}

	reloadComponenteDeCanaisDeVenda() {
		this.reloadCanaisDeVenda = true
		setTimeout(() => {
			this.reloadCanaisDeVenda = false
		}, 10)
	}

	reloadComponenteDeVideos() {
		this.reloadVideos = true
		setTimeout(() => {
			this.reloadVideos = false
		}, 10)
	}

	getIconeMarketplace(codigo: any) {
		switch(codigo) {
			case '1':
				return require('@/assets/icones/amazon_logo.svg')
			case '2':
				return require('@/assets/icones/casasbahia_logo.svg')
			case '7':
				return require('@/assets/icones/mercado_livre_logo.svg')
			default:
				return 'sem'
		}
	}

	excluirDadoAdicional(key: string) {
		const indice = this.dadosAdicionais.findIndex(dadoAdicional => dadoAdicional.key === key)
		this.dadosAdicionais.splice(indice, 1)
	}

	adicionarDadoAdicional() {
		this.dadosAdicionais.push({
			key: '',
			value: '',
		})
	}

	adicionarImagem() {
		this.imagens.push({
			urlImagem: null,
			idProduto: null,
		})
	}

	removerImagem(indice) {
		this.imagens.splice(indice, 1)
	}
}
